document.addEventListener("DOMContentLoaded", () => {
  const loadMoreBtn = document.getElementById("load-more") as HTMLButtonElement;
  const newsSection = document.getElementById("news-section") as HTMLElement;
  const categoryButtons = document.querySelectorAll(".category-filter");
  const filterHeader = document.querySelector("#category-filters p");
 
  let currentPage = 1;
  const postsPerPage = 6;
  let postCounter = 0;
  let currentCategoryId: string | null = null;
  
  // Get translations from PHP
  const translations = (window as any).THEME_DATA?.translations || {
    filterHeading: 'Select news category:',
    deleteFilter: 'Delete Filter',
    loadMore: 'Load more',
    noPosts: 'No posts found.'
  };
  
  // Get language
  const htmlLang = document.documentElement.lang;
  const lang = htmlLang.split('-')[0];
 
  interface WPPost {
    id: number;
    date: string;
    title: { rendered: string };
    link: string;
    _embedded: {
      'wp:featuredmedia'?: [{ source_url: string }];
      'wp:term'?: any[];
    };
  }
 
  
  const fetchPosts = async (page: number, categoryId: string | null = null) => {
    let url = `${window.location.origin}/wp-json/wp/v2/posts?_embed&page=${page}&per_page=${postsPerPage}`;
    
    // Add language filter for Polylang
    if (lang) {
      url += `&lang=${lang}`;
    }
    
    // add post category to url if a category is selected
    if (categoryId) {
      url += `&categories=${categoryId}`;
    }
 
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
 
      const posts = (await response.json()) as WPPost[];
      const totalPages = parseInt(response.headers.get("X-WP-TotalPages") || "1");
 
      return { posts, totalPages };
    } catch (err) {
      console.error("Error loading posts:", err);
      return null;
    }
  };
 
 
  const renderPosts = (posts: WPPost[], append = true) => {
 
    if (!append) {
      newsSection.innerHTML = '';
      postCounter = 0;
    }
 
      let row = document.createElement("div");
      row.className = "row d-flex align-items-stretch news-row";
      newsSection.appendChild(row);
 
      posts.forEach((post, index) => {
              const imageUrl = post._embedded?.['wp:featuredmedia']?.[0]?.source_url 
              || `${window.location.origin}/wp-content/themes/kita-creche/Assets/Images/Blog_Placeholder_1.1.png`;
          
              const postDate = new Date(post.date).toLocaleDateString(lang === 'de' ? 'de-DE' : 'en-US', {
              day: "2-digit",
              month: "long",
              year: "numeric",
          });
 
          let categoryIconHTML = "";
          const categoryGroups = post._embedded?.["wp:term"];
          if (categoryGroups && Array.isArray(categoryGroups)) {
              const categories = categoryGroups[0];
              if (categories && Array.isArray(categories)) {
                  categories.forEach((cat: any) => {
                      const icon = cat.acf?.CategoryIcon;
                      if (icon) {
                          categoryIconHTML += `<div class="category-icon position-absolute">${icon}</div>`;
                      }
                  });
              }
          }
 
          const postElement = document.createElement("div");
          postElement.className =
              "col-12 col-md-6 col-lg-4 mb-4 d-flex flex-column align-items-start justify-content-start position-relative";
 
          postElement.innerHTML = `
              <a href="${post.link}" class="news-link w-100 text-decoration-none">
                  ${categoryIconHTML}
                  ${
                      imageUrl
                          ? `<div class="news-image-wrapper">
                              <img src="${imageUrl}" alt="" class="img-fluid">
                          </div>`
                          : ""
                  }
                  <p class="copy-light-subheading mb-0 mt-4">${postDate}</p>
                  <p class="subline news-title">${post.title.rendered}</p>
              </a>
          `;
 
          row.appendChild(postElement);
          postCounter++;
 
          if (postCounter % 3 === 0 && index < posts.length - 1) {
              row = document.createElement("div");
              row.className = "row d-flex align-items-stretch news-row";
              newsSection.appendChild(row);
          }
      });
 
          if (loadMoreBtn) {
            loadMoreBtn.style.display = "inline-block";
          }
 
  };
 
  const handleLoadMore = async () => {
    currentPage++;
    const data = await fetchPosts(currentPage, currentCategoryId);
 
    if (data && data.posts.length) {
      renderPosts(data.posts, true);
      if (currentPage >= data.totalPages) {
        loadMoreBtn.style.display = "none";
      } else {
        loadMoreBtn.style.display = "inline-block";
      }
    } else {
      loadMoreBtn.style.display = "none";
    }
  };
  
 
  const handleCategoryClick = async (categoryId: string, categoryName: string) => {
    if (categoryId === currentCategoryId) {
      currentCategoryId = null;

      if (filterHeader) {
        filterHeader.textContent = translations.filterHeading;
        filterHeader.classList.remove('clickable');
      }
 
      categoryButtons.forEach((btn) => {
        btn.classList.remove("active");
      });
 
      const data = await fetchPosts(currentPage);
      if (data) {
        renderPosts(data.posts, false);
 
        if (data.totalPages > 1) {
          loadMoreBtn.style.display = "inline-block";
        } else {
          loadMoreBtn.style.display = "none";
        }
      }
    } else {
      currentPage = 1;
      currentCategoryId = categoryId;
      
      // ✅ USE TRANSLATIONS FROM JSON
      if(filterHeader){
        filterHeader.textContent = translations.deleteFilter;
        filterHeader.classList.add('clickable');
      }
 
      categoryButtons.forEach((btn) => {
        btn.classList.remove("active");
      });
 
      const clickedButton = document.querySelector(`[data-category="${categoryId}"]`) as HTMLButtonElement;
      if (clickedButton) {
        clickedButton.classList.add("active");
      }
 
      const data = await fetchPosts(currentPage, currentCategoryId);
      if (data) {
        renderPosts(data.posts, false);
        if (data.totalPages > 1) {
          loadMoreBtn.style.display = "inline-block";
        } else {
          loadMoreBtn.style.display = "none";
        }
      }
    }
  };
 
 
  if (loadMoreBtn && newsSection) {
    loadMoreBtn.addEventListener("click", handleLoadMore);
  }
 
  categoryButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const categoryId = button.getAttribute("data-category");
      const name = button.querySelector(".news-title")?.textContent?.trim() || "Filter";
      if (categoryId) {
        handleCategoryClick(categoryId, name);
      }
    });
  });

  // Delete Filter Logic 
  if (filterHeader) {
    filterHeader.addEventListener("click", async (event) => {
      event.preventDefault();
      if (currentCategoryId) {
        currentCategoryId = null;
        currentPage = 1;
  
        // USE TRANSLATIONS FROM JSON
        filterHeader.textContent = translations.filterHeading;
        filterHeader.classList.remove("clickable");
  
        categoryButtons.forEach((btn) => btn.classList.remove("active"));
  
        const data = await fetchPosts(currentPage);
        if (data) {
          renderPosts(data.posts, false);
          loadMoreBtn.style.display = data.totalPages > 1 ? "inline-block" : "none";
        }
      }
    });
  }
 
});